import React, { memo } from "react";
import type { ModalRootProps } from "./types";

// Web portal not available on React Native
// Native modal implementation would use RN-specific approach
export const ModalRoot = memo(
  ({ modals: _modals, testID: _testID }: ModalRootProps) => {
    return null;
  }
);

ModalRoot.displayName = "ModalRoot";
